webpackJsonp([11404847574495],{

/***/ 1488:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PatientContactDetailsInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isPrimaryContact","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"relationshipId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"shareMedicalRecords","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-patient-contact-details-input-76c0656f559b7aeb3485.js